function initPreApresSizeGuides(scope = document) {
  const sections = [...scope.querySelectorAll('.pa-product')];
  if (scope.matches?.('.pa-product')) sections.push(scope);
  sections.forEach(section => {
    if (section.paSizeGuideCleanup) return;
    const source = section.querySelector('[data-pa-approved-guide]');
    const picker = section.querySelector('variant-radios, variant-selects');
    if (!source?.querySelector('tbody tr') || !picker) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'pa-size-dialog';
    const heading = document.createElement('h2');
    heading.textContent = window.preApresStrings?.sizeGuide || 'Size/Fit Guide';
    heading.id = `SizeGuide-${section.id}`;
    dialog.id = `SizeGuideDialog-${section.id}`;
    dialog.setAttribute('aria-labelledby', heading.id);
    const header = document.createElement('header');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'pa-size-dialog-close';
    close.setAttribute('aria-label', window.preApresStrings?.close || 'Close');
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="m5 5 14 14M19 5 5 19" stroke="currentColor" stroke-width="1.3"/></svg>';
    header.append(heading, close);
    const content = source.querySelector('.pa-size-guide-content').cloneNode(true);
    const units = content.querySelector('[data-pa-guide-units]');
    if (units) {
      units.hidden = false;
      units.querySelectorAll('[data-pa-unit]').forEach(button => {
        button.addEventListener('click', () => {
          const inches = button.dataset.paUnit === 'inches';
          content.querySelectorAll('[data-pa-cm]').forEach(cell => {
            const cm = cell.dataset.paCm;
            const value = Number(cm.replace(',', '.'));
            cell.textContent = inches && Number.isFinite(value) ? (value / 2.54).toFixed(1) : cm;
          });
          content.querySelectorAll('[data-pa-guide-unit]').forEach(label => { label.textContent = button.textContent; });
          units.querySelectorAll('[data-pa-unit]').forEach(option => {
            option.setAttribute('aria-pressed', String(option === button));
          });
        });
      });
    }
    dialog.append(header, content);
    source.hidden = true;
    section.append(dialog);
    let opener = null;
    const ensureButton = () => {
      if (picker.querySelector('.pa-size-guide-button')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pa-size-guide-button';
      button.textContent = `[ ${heading.textContent} ]`;
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', dialog.id);
      button.addEventListener('click', () => {
        opener = button;
        dialog.showModal();
        document.documentElement.classList.add('pa-size-guide-open');
      });
      const fieldset = picker.querySelector('fieldset');
      if (fieldset) fieldset.append(button); else picker.before(button);
    };
    ensureButton();
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('pa-size-guide-open');
      opener?.isConnected && opener.focus({ preventScroll: true });
    });
    const observer = new MutationObserver(ensureButton);
    observer.observe(picker, { childList: true, subtree: true });
    section.paSizeGuideCleanup = () => { observer.disconnect(); dialog.close(); };
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresSizeGuides());
document.addEventListener('shopify:section:load', event => initPreApresSizeGuides(event.target));

/* Desktop photos scroll within the same height as the information column.
   Native overflow chains back to the page at either end; mobile keeps Embla. */
function initPreApresGalleryScroll(scope = document) {
  scope.querySelectorAll('.pa-product').forEach(section => {
    if (section.paGalleryCleanup) return;
    const media = section.querySelector('.product-media');
    const viewport = media?.querySelector('[data-pa-gallery-scroll] > .embla__viewport');
    const info = section.querySelector('.product__info-wrapper');
    if (!viewport || !info) return;
    const desktop = window.matchMedia('(min-width: 990px)');
    let frame;
    const update = () => {
      if (!desktop.matches) {
        media.classList.remove('pa-gallery-scroll');
        media.style.removeProperty('--pa-gallery-height');
        viewport.removeAttribute('tabindex');
        return;
      }
      // Keep one large photograph visible even on products with little copy.
      const availableHeight = window.innerHeight - (document.querySelector('.header-wrapper')?.offsetHeight || 0) - 32;
      const height = Math.ceil(Math.max(info.getBoundingClientRect().height, availableHeight, 520));
      media.style.setProperty('--pa-gallery-height', `${height}px`);
      media.classList.add('pa-gallery-scroll');
      viewport.setAttribute('tabindex', '0');
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    const observer = new ResizeObserver(schedule);
    observer.observe(info);
    desktop.addEventListener('change', schedule);
    window.addEventListener('resize', schedule);
    section.paGalleryCleanup = () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      desktop.removeEventListener('change', schedule);
      window.removeEventListener('resize', schedule);
    };
    update();
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresGalleryScroll());
document.addEventListener('shopify:section:load', event => initPreApresGalleryScroll(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.pa-product').forEach(section => section.paGalleryCleanup?.());
});

/* Named native details supply exclusivity; this also covers older browsers. */
document.addEventListener('toggle', event => {
  const detail = event.target;
  if (!(detail instanceof HTMLDetailsElement) || !detail.open || !detail.matches('.pa-product-story,.pa-product-detail')) return;
  detail.closest('.pa-product')?.querySelectorAll('.pa-product-story[open],.pa-product-detail[open]').forEach(other => {
    if (other !== detail) other.open = false;
  });
}, true);

function initPreApresMenus(scope = document) {
  scope.querySelectorAll('[data-pa-menu]').forEach(container => {
    if (container.paMenuInitialized) return;
    container.paMenuInitialized = true;
    const button = container.querySelector('[data-pa-menu-toggle]');
    const setOpen = open => {
      container.classList.toggle('pa-menu-open', open);
      button.setAttribute('aria-expanded', String(open));
    };
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      container.classList.toggle('pa-menu-dismissed', !open);
      setOpen(open);
    });
    container.addEventListener('mouseenter', () => {
      container.classList.remove('pa-menu-dismissed');
      setOpen(true);
    });
    container.addEventListener('mouseleave', () => {
      if (!container.contains(document.activeElement)) setOpen(false);
      container.classList.remove('pa-menu-dismissed');
    });
    container.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!container.contains(document.activeElement)) {
          setOpen(false);
          container.classList.remove('pa-menu-dismissed');
        }
      });
    });
    container.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      setOpen(false);
      container.classList.add('pa-menu-dismissed');
      button.focus();
    });
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresMenus());
document.addEventListener('shopify:section:load', event => initPreApresMenus(event.target));

/* Do not leave a hidden drawer trapping focus or page scroll after a resize. */
function initPreApresHeaderLayout(scope = document) {
  scope.querySelectorAll('.header-wrapper .header').forEach(header => {
    if (header.paHeaderCleanup) return;
    const desktop = window.matchMedia('(min-width: 990px)');
    const logo = header.querySelector(':scope > .header__heading .header__heading-logo, :scope > .header__heading-link .header__heading-logo');
    const menu = header.querySelector('.header__inline-menu');
    const word = menu?.querySelector('.header__menu-item span');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d', { willReadFrequently: true });
    const logoPixels = new Image();
    logoPixels.crossOrigin = 'anonymous';
    let bottomInset = 0;
    let alignmentFrame = 0;
    const align = () => {
      alignmentFrame = 0;
      if (!desktop.matches || !logo?.complete || !logo.naturalWidth || !word || !context) return;
      const logoRect = logo.getBoundingClientRect();
      const wordRect = word.getBoundingClientRect();
      const style = getComputedStyle(word);
      context.font = style.font;
      const metrics = context.measureText(word.textContent.trim());
      const ascent = metrics.fontBoundingBoxAscent;
      const descent = metrics.fontBoundingBoxDescent;
      const inkGap = Number.isFinite(ascent + descent) ?
        (parseFloat(style.lineHeight) - ascent + descent) / 2 - metrics.actualBoundingBoxDescent : 2.5;
      const offset = parseFloat(getComputedStyle(menu).marginTop) || 0;
      const logoBottom = logoRect.bottom - logoRect.height * bottomInset;
      const wordBottom = wordRect.bottom - offset - inkGap;
      header.style.setProperty('--pa-header-nav-offset', `${logoBottom - wordBottom}px`);
    };
    const scheduleAlignment = () => {
      if (!alignmentFrame) alignmentFrame = requestAnimationFrame(align);
    };
    const readLogo = () => {
      if (!logoPixels.complete || !logoPixels.naturalWidth || !context) return;
      canvas.width = Math.min(1024, logoPixels.naturalWidth);
      canvas.height = Math.max(1, Math.round(canvas.width * logoPixels.naturalHeight / logoPixels.naturalWidth));
      bottomInset = 0;
      try {
        context.drawImage(logoPixels, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let lastRow = canvas.height - 1;
        for (; lastRow >= 0; lastRow--) {
          let occupied = false;
          for (let x = 0; x < canvas.width; x++) {
            if (pixels[(lastRow * canvas.width + x) * 4 + 3] > 16) { occupied = true; break; }
          }
          if (occupied) break;
        }
        if (lastRow >= 0) bottomInset = (canvas.height - lastRow - 1) / canvas.height;
      } catch { bottomInset = 0; }
      scheduleAlignment();
    };
    const loadLogo = () => {
      if (!logo?.complete || !logo.naturalWidth) return;
      if (logoPixels.src !== logo.currentSrc) logoPixels.src = logo.currentSrc;
      else readLogo();
    };
    logoPixels.addEventListener('load', readLogo);
    logoPixels.addEventListener('error', scheduleAlignment);
    const alignmentObserver = new ResizeObserver(scheduleAlignment);
    alignmentObserver.observe(header);
    if (logo) {
      alignmentObserver.observe(logo);
      logo.addEventListener('load', loadLogo);
      loadLogo();
    }
    document.fonts.ready.then(() => { if (header.isConnected) scheduleAlignment(); });
    desktop.addEventListener('change', scheduleAlignment);
    const sync = event => {
      header.querySelectorAll('[data-pa-menu]').forEach(menu => {
        menu.classList.remove('pa-menu-open', 'pa-menu-dismissed');
        menu.querySelector('[data-pa-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      const drawer = header.querySelector('header-drawer');
      if (desktop.matches && drawer?.mainDetailsToggle?.open && !drawer.classList.contains('header-drawer--desktop')) {
        const focusTarget = drawer.contains(document.activeElement) ? header.querySelector('.header__heading-link') : false;
        drawer.closeMenuDrawer(event, focusTarget);
      }
    };
    desktop.addEventListener('change', sync);
    header.paHeaderCleanup = () => {
      desktop.removeEventListener('change', sync);
      desktop.removeEventListener('change', scheduleAlignment);
      logo?.removeEventListener('load', loadLogo);
      logoPixels.removeEventListener('load', readLogo);
      logoPixels.removeEventListener('error', scheduleAlignment);
      alignmentObserver.disconnect();
      cancelAnimationFrame(alignmentFrame);
    };
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresHeaderLayout());
document.addEventListener('shopify:section:load', event => initPreApresHeaderLayout(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('.header-wrapper .header').forEach(header => header.paHeaderCleanup?.());
});

/* One controller owns the reference header; native StickyHeader remains the
   fallback when the merchant disables this behavior. Do not hide open dialogs
   or keyboard focus, and keep the mobile header on a solid background. */
function initPreApresHeaderScroll(scope = document) {
  scope.querySelectorAll('[data-pa-reference-header]').forEach(wrapper => {
    if (wrapper.paScrollCleanup) return;
    const section = wrapper.closest('.shopify-section-header');
    if (!section) return;
    const firstSection = document.querySelector('#MainContent')?.firstElementChild;
    const storyHero = firstSection?.querySelector('[data-story-header-hero]');
    const hero = storyHero || (document.body.classList.contains('template-index') && firstSection?.querySelector('.pa-editorial--hero'));
    const desktop = window.matchMedia('(min-width: 990px)');
    let previousY = Math.max(0, window.scrollY);
    let frame = 0;
    let floating = false;
    let originTop = 0;
    const natural = () => !!hero && (desktop.matches || !!storyHero);
    const measure = () => section.style.setProperty('--pa-header-height', `${wrapper.offsetHeight}px`);
    const expanded = () => wrapper.querySelector('details[open], [data-pa-menu-toggle][aria-expanded="true"]') ||
      wrapper.contains(document.activeElement) || document.querySelector('cart-drawer.active');
    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const delta = y - previousY;
      section.classList.toggle('pa-header-natural', natural());
      if (natural()) {
        if (!floating) originTop = section.getBoundingClientRect().top + y;
        if (!floating && y >= originTop + wrapper.offsetHeight) {
          floating = true;
          section.classList.toggle('pa-header-hidden', delta >= 0 && !expanded());
        } else if (floating && y <= originTop) floating = false;
        section.classList.toggle('pa-header-floating', floating);
        const heroRect = hero.getBoundingClientRect();
        const overHero = heroRect.top <= 0 && heroRect.bottom >= wrapper.offsetHeight;
        section.classList.toggle('pa-header-at-top', !floating || overHero);
        if (!floating || expanded()) section.classList.remove('pa-header-hidden');
        else if (Math.abs(delta) > 4) section.classList.toggle('pa-header-hidden', delta > 0);
      } else {
        floating = false;
        section.classList.remove('pa-header-floating', 'pa-header-at-top');
        if (y <= 8 || expanded()) section.classList.remove('pa-header-hidden');
        else if (Math.abs(delta) > 4) section.classList.toggle('pa-header-hidden', delta > 0 && y > wrapper.offsetHeight);
      }
      // Accumulate very small trackpad movements until they establish direction.
      if (Math.abs(delta) > 4 || y <= 8) previousY = y;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const reveal = () => {
      update();
      section.classList.remove('pa-header-hidden');
    };
    const resize = () => { measure(); reveal(); schedule(); };
    const observer = new ResizeObserver(measure);
    observer.observe(wrapper);
    window.addEventListener('scroll', schedule, { passive: true });
    desktop.addEventListener('change', resize);
    wrapper.addEventListener('focusin', reveal);
    wrapper.addEventListener('toggle', schedule, true);
    // Prevent editor section selection from leaving its controls off screen.
    section.addEventListener('shopify:section:select', reveal);
    wrapper.paScrollCleanup = () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      desktop.removeEventListener('change', resize);
      wrapper.removeEventListener('focusin', reveal);
      wrapper.removeEventListener('toggle', schedule, true);
      section.removeEventListener('shopify:section:select', reveal);
    };
    section.classList.toggle('pa-header-story', !!storyHero);
    section.classList.toggle('pa-header-natural', natural());
    measure();
    update();
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresHeaderScroll());
document.addEventListener('shopify:section:load', event => initPreApresHeaderScroll(event.target));

// Keep the selected colour visible and expose the remaining colours on demand.
function packPreApresColours(row) {
  if (!row) return;
  if (!row.paAllColours) row.paAllColours = Array.from(row.querySelectorAll('[data-pa-colour-id]'));
  const all = row.paAllColours;
  const limit = window.innerWidth < 360 ? 2 : window.innerWidth < 750 ? 3 : all.length;
  const visible = all.slice(0, limit);
  const selected = all.find(item => item.querySelector('[aria-current="page"]'));
  if (selected && !visible.includes(selected)) visible[visible.length - 1] = selected;
  const rest = all.filter(item => !visible.includes(item));
  row.replaceChildren(...visible);
  if (!rest.length) return;
  const details = document.createElement('details');
  details.className = 'pa-colour-more';
  const summary = document.createElement('summary');
  summary.textContent = `+${rest.length}`;
  summary.setAttribute('aria-label', row.dataset.paMoreLabel.replace('{count}', rest.length));
  const panel = document.createElement('div');
  panel.className = 'pa-colour-more__panel';
  panel.append(...rest);
  details.append(summary, panel);
  row.append(details);
}
let preApresColourWidth = window.innerWidth < 360 ? 2 : window.innerWidth < 750 ? 3 : Infinity;
window.addEventListener('resize', () => {
  const limit = window.innerWidth < 360 ? 2 : window.innerWidth < 750 ? 3 : Infinity;
  if (limit === preApresColourWidth) return;
  preApresColourWidth = limit;
  document.querySelectorAll('.pa-card-colours').forEach(packPreApresColours);
});
document.addEventListener('click', event => {
  document.querySelectorAll('.pa-colour-more[open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.pa-colour-more[open]').forEach(details => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
// A colour change carries a deliberately selected size only when it is available.
document.addEventListener('click', event => {
  const swatch = event.target.closest('[data-pa-product-colours] .pa-colour-swatch');
  if (!swatch || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const root = swatch.closest('[data-product-details]');
  if (!root) return;
  const fields = Array.from(root.querySelectorAll('variant-radios fieldset'));
  const field = fields.find(item => /^(size|størrelse|strørrelse)$/i.test(item.getAttribute('aria-label') || ''));
  let size = field?.querySelector('input:checked')?.value;
  if (!size) size = Array.from(root.querySelectorAll('variant-selects select')).find(item => /^(size|størrelse|strørrelse)$/i.test(item.name))?.value;
  const position = Number(swatch.dataset.paSizePosition);
  if (!size || position < 0) return;
  let variants;
  try { variants = JSON.parse(swatch.dataset.paVariants); } catch { return; }
  const variant = variants.find(item => item.available && item.options[position] === size);
  const url = new URL(swatch.href, location.href);
  if (variant) url.searchParams.set('variant', variant.id);
  else { url.searchParams.delete('variant'); url.searchParams.set('pa_size_unavailable', size); }
  event.preventDefault();
  location.assign(url.href);
});
function initPreApresSizeNotice(scope = document) {
  const size = new URL(location.href).searchParams.get('pa_size_unavailable');
  if (!size) return;
  scope.querySelectorAll('[data-pa-size-notice]').forEach(notice => {
    notice.textContent = notice.dataset.paMessage.replace('{size}', size);
    notice.hidden = false;
  });
}
document.addEventListener('DOMContentLoaded', () => initPreApresSizeNotice());
document.addEventListener('shopify:section:load', event => initPreApresSizeNotice(event.target));
// Shopify Inbox's icon stays a 44px touch target on small screens.
function initPreApresChatIcon() {
  document.querySelectorAll('shopify-chat').forEach(chat => {
    const root = chat.shadowRoot;
    if (!root || root.getElementById('pa-mobile-chat-style')) return;
    const style = document.createElement('style');
    style.id = 'pa-mobile-chat-style';
    style.textContent = '@media(max-width:749px){.activator{width:44px!important;min-width:44px!important;height:44px!important;min-height:44px!important;padding:0!important;gap:0!important}.activator__label{display:none!important}.activator__icon{width:20px!important;height:20px!important}}';
    root.append(style);
  });
}
document.addEventListener('DOMContentLoaded', () => {
  initPreApresChatIcon();
  customElements.whenDefined('shopify-chat').then(initPreApresChatIcon);
  new MutationObserver(initPreApresChatIcon).observe(document.body, {childList:true, subtree:true});
});

document.addEventListener('click', event => {
  const swatch = event.target.closest('.pa-card-colours .pa-colour-swatch');
  if (!swatch || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const card = swatch.closest('.pa-product-card');
  const id = swatch.parentElement.dataset.paColourId;
  const option = Array.from(card.querySelectorAll(':scope > .pa-card-option'))
    .find(template => template.dataset.paColourId === id);
  const nextCard = option?.content.querySelector('.pa-product-card');
  if (!nextCard) return;
  event.preventDefault();
  const colours = card.querySelector('.pa-card-colours');
  const link = nextCard.querySelector(':scope > .full-unstyled-link').cloneNode(true);
  card.querySelector(':scope > .full-unstyled-link').replaceWith(link);
  link.querySelector('.pa-card-headline').append(colours);
  card.querySelector(':scope > .pa-card-status')?.remove();
  const status = nextCard.querySelector(':scope > .pa-card-status');
  if (status) card.append(status.cloneNode(true));
  card.dataset.paProductId = id;
  card.dataset.paImageNumber = nextCard.dataset.paImageNumber;
  card.querySelectorAll('.pa-card-colours .pa-colour-swatch').forEach(item => {
    if (item === swatch) item.setAttribute('aria-current', 'page');
    else item.removeAttribute('aria-current');
  });
  packPreApresColours(colours);
  link.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
});

let preApresColourCatalog;
function loadPreApresColourCatalog() {
  if (preApresColourCatalog) return preApresColourCatalog;
  preApresColourCatalog = (async () => {
    const families = new Map();
    const root = window.Shopify?.routes?.root || '/';
    let next = new URL(`${root}collections/all`, location.origin).href;
    const seen = new Set();
    while (next) {
      const url = new URL(next, location.href);
      url.searchParams.set('section_id', 'pa-colour-catalog');
      if (seen.has(url.href)) throw new Error('Colour catalogue pagination repeated');
      seen.add(url.href);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Colour catalogue unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const catalog = html.querySelector('[data-pa-colour-catalog]');
      if (!catalog) throw new Error('Colour catalogue missing');
      catalog.querySelectorAll(':scope > [data-pa-catalog-colour]').forEach(option => {
        const key = option.dataset.paModel.trim();
        const family = families.get(key) || [];
        if (!family.some(item => item.dataset.paColourId === option.dataset.paColourId)) family.push(option);
        families.set(key, family);
      });
      next = catalog.dataset.paNext;
    }
    return families;
  })().catch(error => {
    preApresColourCatalog = undefined;
    throw error;
  });
  return preApresColourCatalog;
}

async function initPreApresColourChoices(scope = document) {
  const selector = '[data-pa-family-colours], [data-pa-product-colours]';
  const targets = [...scope.querySelectorAll(selector)];
  if (scope.matches?.(selector)) targets.unshift(scope);
  const pending = targets.filter(target => !target.dataset.paColoursBound);
  if (!pending.length) return;
  pending.forEach(target => { target.dataset.paColoursBound = 'loading'; });
  try {
    const families = await loadPreApresColourCatalog();
    for (const target of pending) {
      if (!target.isConnected) continue;
      const family = families.get(target.dataset.paModel.trim());
      if (!family?.length) {
        target.dataset.paColoursBound = 'ready';
        continue;
      }
      const current = target.dataset.paProductId;
      const makeColour = option => {
        const colour = option.content.querySelector('[data-pa-colour-id]').cloneNode(true);
        const link = colour.querySelector('a');
        if (option.dataset.paColourId === current) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
        return colour;
      };
      if (target.hasAttribute('data-pa-family-colours')) {
        const colours = target.querySelector('.pa-card-colours');
        delete colours.paAllColours;
        colours.replaceChildren(...family.map(makeColour));
        packPreApresColours(colours);
        target.querySelectorAll(':scope > .pa-card-option').forEach(option => option.remove());
        family.forEach(option => target.append(option.content.querySelector('.pa-card-option').cloneNode(true)));
      } else {
        const groups = ['standard', 'washed'].map(finish => family.filter(option => option.dataset.paFinish.trim() === finish));
        target.replaceChildren();
        groups.forEach((options, index) => {
          if (!options.length) return;
          const group = document.createElement('div');
          group.className = 'pa-colour-options__group';
          if (groups.every(items => items.length)) {
            const heading = document.createElement('p');
            heading.className = 'pa-colour-options__heading';
            heading.textContent = index ? target.dataset.paWashedLabel : target.dataset.paCoreLabel;
            group.append(heading);
          }
          const row = document.createElement('div');
          row.className = 'pa-colour-options__row';
          row.append(...options.map(option => makeColour(option).querySelector('a')));
          group.append(row);
          target.append(group);
        });
      }
      target.dataset.paColoursBound = 'ready';
    }
  } catch (error) {
    pending.forEach(target => { delete target.dataset.paColoursBound; });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initPreApresColourChoices();
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) initPreApresColourChoices(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
});
document.addEventListener('shopify:section:load', event => initPreApresColourChoices(event.target));

async function initPreApresModelGrids(scope = document) {
  const grids = Array.from(scope.querySelectorAll('[data-pa-model-grid]'));
  for (const grid of grids) {
    if (grid.dataset.paBound) continue;
    grid.dataset.paBound = 'true';
    const wrapper = grid.closest('.template-search__results') || grid.closest('.collection');
    const pager = wrapper.querySelector('.pa-model-pagination');
    const nativePager = wrapper.querySelector('.pa-native-pagination');
    const pageSize = Math.max(1, Number(grid.dataset.paPageSize) || 16);
    let next = grid.dataset.paNext;
    let complete = true;
    const seenPages = new Set();
    const imageBanners = Array.from(grid.querySelectorAll(':scope > .pa-collection-image'));
    const models = new Map(Array.from(grid.querySelectorAll(':scope > .pa-model-item'))
      .map(item => [item.dataset.paModel, item]));
    try {
      while (next && !seenPages.has(next)) {
        seenPages.add(next);
        const url = new URL(next, location.href);
        url.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!grid.isConnected) break;
        const pageGrid = html.querySelector('[data-pa-model-grid]');
        if (!pageGrid) throw new Error('Collection grid unavailable');
        pageGrid.querySelectorAll(':scope > .pa-model-item').forEach(item => {
          const existing = models.get(item.dataset.paModel);
          if (!existing) {
            models.set(item.dataset.paModel, item);
            grid.append(item);
            return;
          }
          if (grid.dataset.paSaleLast === 'true' && existing.dataset.paSale === 'true' && item.dataset.paSale === 'false') {
            existing.replaceWith(item);
            models.set(item.dataset.paModel, item);
            return;
          }
          const card = existing.querySelector('.pa-product-card');
          if (!card) return;
          const colours = card.querySelector('.pa-card-colours');
          if (!colours) return;
          item.querySelectorAll('.pa-card-colours > [data-pa-colour-id]').forEach(colour => {
            if (!Array.from(colours.children).some(c => c.dataset.paColourId === colour.dataset.paColourId)) {
              colour.querySelector('a').removeAttribute('aria-current');
              colours.append(colour);
            }
          });
          item.querySelectorAll(':scope > .pa-product-card > .pa-card-option').forEach(option => {
            if (!Array.from(card.querySelectorAll(':scope > .pa-card-option')).some(t => t.dataset.paColourId === option.dataset.paColourId)) card.append(option);
          });
        });
        next = pageGrid.dataset.paNext;
      }
    } catch (error) {
      complete = false;
    }
    if (!grid.isConnected) continue;
    if (!complete) continue;
    nativePager?.setAttribute('hidden', '');
    const items = Array.from(models.values());
    if (grid.dataset.paSaleLast === 'true') {
      items.sort((a, b) => Number(a.dataset.paSale === 'true') - Number(b.dataset.paSale === 'true'));
      items.forEach(item => grid.append(item));
    }
    const pages = Math.ceil(items.length / pageSize);
    const pageUrl = page => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      if (page > 1) url.searchParams.set('pa_page', page);
      else url.searchParams.delete('pa_page');
      return url;
    };
    const showPage = (page, updateHistory = false) => {
      page = Math.min(Math.max(1, page), pages || 1);
      items.forEach((item, index) => { item.hidden = index < (page - 1) * pageSize || index >= page * pageSize; });
      const pageStart = (page - 1) * pageSize;
      const pageEnd = Math.min(page * pageSize, items.length);
      const imageAnchors = new Map();
      imageBanners.forEach(banner => {
        const after = banner.dataset.paPlacement === 'end' ? items.length : Number(banner.dataset.paAfterProducts);
        banner.hidden = after <= pageStart || after > pageEnd;
        if (banner.hidden) return;
        const anchor = imageAnchors.get(after) || items[after - 1];
        anchor.after(banner);
        imageAnchors.set(after, banner);
      });
      const breaker = grid.querySelector(':scope > .breaker');
      if (breaker) breaker.hidden = page > 1;
      pager.replaceChildren();
      pager.hidden = pages <= 1;
      if (pages > 1) {
        const makeLink = (label, number) => {
          const link = document.createElement('a');
          link.href = pageUrl(number).href;
          link.textContent = label;
          link.dataset.paPage = number;
          if (label === '←') link.setAttribute('aria-label', grid.dataset.paPrevious || 'Previous page');
          if (label === '→') link.setAttribute('aria-label', grid.dataset.paNextLabel || 'Next page');
          if (number === page && /^\d+$/.test(label)) link.setAttribute('aria-current', 'page');
          pager.append(link);
        };
        if (page > 1) makeLink('←', page - 1);
        for (let number = 1; number <= pages; number++) makeLink(String(number), number);
        if (page < pages) makeLink('→', page + 1);
      }
      const count = document.getElementById('ProductCount');
      const countText = `${items.length} ${items.length === 1 ? grid.dataset.paModelLabelOne : grid.dataset.paModelLabel}`;
      if (count) count.textContent = countText;
      document.querySelectorAll('#main-search-filters .mobile-facets__count, #main-search-filters .collection-product-count, #main-collection-filters .mobile-facets__count').forEach(count => { count.textContent = countText; });
      grid.dataset.paReady = 'true';
      if (updateHistory) history.pushState({ paModelPage: page }, '', pageUrl(page));
    };
    const requestedPage = Number(new URL(location.href).searchParams.get('pa_page')) || 1;
    showPage(requestedPage);
    pager.addEventListener('click', event => {
      const link = event.target.closest('[data-pa-page]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      showPage(Number(link.dataset.paPage), true);
      grid.scrollIntoView({ block: 'start' });
    });
    grid.paModelShowPage = showPage;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initPreApresModelGrids();
  const container = document.getElementById('ProductGridContainer');
  if (container) new MutationObserver(() => initPreApresModelGrids(container))
    .observe(container, { childList: true });
});
document.addEventListener('shopify:section:load', event => initPreApresModelGrids(event.target));
window.addEventListener('popstate', () => {
  document.querySelectorAll('[data-pa-model-grid]').forEach(grid => {
    grid.paModelShowPage?.(Number(new URL(location.href).searchParams.get('pa_page')) || 1);
  });
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-pa-reference-header]').forEach(wrapper => wrapper.paScrollCleanup?.());
});

/* Reopen Orbe with the shopper's existing choice. Orbe continues to own the
   country list, localization submit and preference cookies. Delegation also
   works after the editor replaces the header section. */
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-pa-country-trigger]');
  if (!trigger) return;
  const modal = document.getElementById('md-app-embed__modal');
  if (!modal || typeof orbito === 'undefined' || typeof orbito.openModalWithoutRefresh !== 'function') {
    // The link still leads to the existing footer selector if Orbe is delayed.
    return;
  }
  event.preventDefault();
  const closeButton = modal.querySelector('.md-modal-closeButtonAction');
  const previousDisplay = closeButton?.style.getPropertyValue('display');
  const previousPriority = closeButton?.style.getPropertyPriority('display');
  modal.setAttribute('data-pa-country-manual', '');
  trigger.setAttribute('aria-expanded', 'true');
  // The welcome popup hides this button. A manually reopened picker can be
  // cancelled; restoring its inline style leaves the first-visit policy intact.
  closeButton?.style.setProperty('display', 'flex', 'important');
  const onKeyDown = keyEvent => {
    if (keyEvent.key !== 'Escape' || keyEvent.defaultPrevented || modal.querySelector('[role="combobox"][aria-expanded="true"]')) return;
    keyEvent.preventDefault();
    orbito.closeModal('md-app-embed__modal');
  };
  const observer = new MutationObserver(() => {
    if (modal.getAttribute('aria-hidden') !== 'true') return;
    observer.disconnect();
    modal.removeEventListener('keydown', onKeyDown);
    modal.removeAttribute('data-pa-country-manual');
    trigger.setAttribute('aria-expanded', 'false');
    if (closeButton) {
      if (previousDisplay) closeButton.style.setProperty('display', previousDisplay, previousPriority);
      else closeButton.style.removeProperty('display');
    }
    if (trigger.isConnected) trigger.focus({ preventScroll: true });
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  modal.addEventListener('keydown', onKeyDown);
  orbito.openModalWithoutRefresh();
  requestAnimationFrame(() => modal.querySelector('#md-form__select__country')?.focus());
});

document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.pa-product').forEach(section => section.paSizeGuideCleanup?.()));
